import { SolidButton, TransparentButton } from '../Button';
import { H4, P } from '../Text';

import AttentionIcon from 'assets/svgs/AttentionIcon';
import BaseModal from './BaseModal';

interface Props {
  closeModal: () => void;
  title: string;
  description: string;
  btn1Text: string;
  btn2Text?: string;
  containerClassName?: string;
  btn1ClassName?: string;
  btn2ClassName?: string;
  modalOpen: boolean;
  icon?: React.JSX.Element;
  handleButton1Click?: () => void;
  handleButton2Click?: () => void;
}

const CautionModal: React.FC<Props> = ({
  closeModal,
  title,
  description,
  btn1Text,
  btn2Text,
  containerClassName,
  btn1ClassName,
  btn2ClassName,
  modalOpen,
  icon,
  handleButton1Click,
  handleButton2Click,
}) => {
  return (
    <BaseModal closeModal={closeModal} modalOpen={modalOpen}>
      <div
        className={`flex flex-col items-center justify-center ${containerClassName}`}>
        {icon || (
          <AttentionIcon
            className="w-16 h-16"
            exclamationColor="var(--tt-light-gray-purple-line)"
            triangleOutlineColor="var(--tt-light-gray-purple-line)"
          />
        )}
        <div className="mt-3 text-center sm:mt-0 sm:text-left">
          <H4 className="!text-lg leading-6 font-medium" centered>
            <b>{title}</b>
          </H4>
          <P className="mt-2" centered>
            {description}
          </P>
        </div>
        <SolidButton
          onClick={() => {
            closeModal();
            if (handleButton1Click) handleButton1Click();
          }}
          className={`${btn1ClassName || 'w-full sm:w-3/4 mt-4'}`}>
          {btn1Text}
        </SolidButton>
        {btn2Text && (
          <TransparentButton
            onClick={() => {
              closeModal();
              if (handleButton2Click) handleButton2Click();
            }}
            className={`${
              btn2ClassName || 'w-full sm:w-3/4 mt-4'
            }`}>
            {btn2Text}
          </TransparentButton>
        )}
      </div>
    </BaseModal>
  );
};

export default CautionModal;
